import React from 'react' 

import Description from './sections/Description'
import BankAccounts from './sections/BankAccounts'

const Donations = () => {
  return(
    <React.Fragment>
      <Description/>
      <BankAccounts/>
    </React.Fragment>

  )
}

export default Donations